import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between background-gray q-py-lg section-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, "Tools > Global Postback")
], -1)
const _hoisted_2 = { class: "section-container" }
const _hoisted_3 = {
  class: "section-container",
  style: {"padding-top":"40px"}
}
const _hoisted_4 = { class: "section-container" }
const _hoisted_5 = { class: "page-subtitle q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_Postbacks = _resolveComponent("Postbacks")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_PostbackLogs = _resolveComponent("PostbackLogs")!
  const _component_PostbackHelp = _resolveComponent("PostbackHelp")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_tabs, {
          modelValue: _ctx.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
          "inline-label": "",
          breakpoint: 0,
          align: "justify",
          class: "q-mt-lg q-mb-xs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab, {
              "no-caps": "",
              name: "settings",
              label: _ctx.$t('settings')
            }, null, 8, ["label"]),
            _createVNode(_component_q_tab, {
              "no-caps": "",
              name: "logs",
              label: _ctx.$t('logs')
            }, null, 8, ["label"]),
            _createVNode(_component_q_tab, {
              "no-caps": "",
              name: "help",
              label: _ctx.$t('reference')
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, {
            name: "settings",
            class: "q-pa-none"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Postbacks, { isGlobal: true }),
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "q-mt-md q-btn__main-size text-weight-bold",
                  unelevated: "",
                  label: _ctx.$t('save'),
                  color: "primary",
                  onClick: _ctx.savePostbacks
                }, null, 8, ["label", "onClick"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "logs",
            class: "q-pa-none",
            style: {"padding-top":"8px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PostbackLogs)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "help",
            class: "q-pa-none",
            style: {"padding-top":"24px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('reference')), 1),
                _createVNode(_component_PostbackHelp)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}